import { TagAcquisition } from "src/swagger-gen/web-secured/models";
import { UnitAcquisitionStateModel } from "./UnitAcquisitionStateModel";

export class TagAcquisitionModel{
    unit: UnitAcquisitionStateModel;
    tags: TagAcquisition[];
    i18n?: string;

    constructor(unit: UnitAcquisitionStateModel, tags: TagAcquisition[], i18n?: string){
        this.unit = unit;
        this.tags = tags;
        this.i18n = i18n;
    }
}
